import React from 'react';
import Modal from '../../../../../components/Modal';
import InfoTable from '../../../../../components/table/InfoTable';
import { setPhoneFormat } from '../../../../../lib/common';
import './DeliveryTrackingModal.scss';

const DeliveryTrackingModal = (props) => {
  const { data, isOpen, closeModal } = props;
  const { kind, shipper, shipperPhone, invoiceNumber, agent, address, list } = data;

  return (
    <Modal
      title="배송 조회"
      isOpen={isOpen}
      width={620}
      height={600}
      isFooter={true}
      onOk={() => closeModal()}
      onClose={() => closeModal()}
    >
      <div className="delivery-tracking-modal">
        <div className="delivery-tracking-info">
          <div className="info-section">
            <div className="delivery-status">{kind ? `배송 상태 : ${kind}` : '배송현황이 확인되지 않습니다.'}</div>
            {kind && (
              <div className="delivery-manager">
                담당자 : {shipper} {shipperPhone ? `(${setPhoneFormat(shipperPhone)})` : null}
              </div>
            )}
          </div>

          <div className="info-section">
            <div className="inline-form">
              <div className="label">운송장 번호</div>
              <div className="content">{invoiceNumber}</div>
            </div>

            <div className="inline-form">
              <div className="label">택배사</div>
              <div className="content">{agent}</div>
            </div>

            <div className="inline-form">
              <div className="label">수령 주소</div>
              <div className="content">{address}</div>
            </div>
          </div>
        </div>

        <InfoTable className="delivery-tracking-details">
          <thead>
            <tr>
              <th>위치</th>
              <th>상태</th>
              <th>처리시간</th>
            </tr>
          </thead>
          <tbody>
            {list.length
              ? list.map((item, index) => {
                  return (
                    <tr key={index}>
                      <td>{item.where}</td>
                      <td>{item.kind}</td>
                      <td>
                        {item.timeString.split(' ')[0]}
                        <br /> {item.timeString.split(' ')[1]}
                      </td>
                    </tr>
                  );
                })
              : null}
          </tbody>
        </InfoTable>
      </div>
    </Modal>
  );
};

export default DeliveryTrackingModal;
